import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../global/context/Provider";
import { GlobalStyle } from "../global/styled/GlobalStyle";
import RouterPortal from "./routes/routes";
import { getLocalStorage } from "global/utils/safeJsonParse";

const PortalContainer = () => {
  const { configState } = useContext(GlobalContext);
  const [appMode, setAppMode] = useState("");
  const isTerminal = !!getLocalStorage("idTerminal");

  useEffect(() => {
    if (configState.config.data) {
      setAppMode(configState.config.data.modoEstilo);
    }
  }, [configState.config.data]);

  return (
    <>
      <GlobalStyle mode={appMode} $isTerminal={isTerminal} />
      <RouterPortal />
    </>
  );
};

export default PortalContainer;
